module.exports = __webpack_public_path__ + "img/lukas-kohlmair.3be6640e.jpg";